import { SimplePopoverPlainOption } from '@dev/ee-components';
import { StatisticsChannelsState } from '@/store/channels/types';

export const channelsOptions = (
    channels: StatisticsChannelsState,
    loadingKey: string,
    resultKey: string,
    isMobile: boolean
): SimplePopoverPlainOption[] => {
    if (channels?.loading) {
        return [{ label: loadingKey, value: 'loading', disabled: true }];
    }
    if (channels?.channels?.length || (isMobile && channels?.channels?.length)) {
        return channels?.channels.map((item) => ({ label: item.Name, value: item.Name }));
    }
    if (isMobile && !channels?.channels?.length) {
        return [];
    }
    return [{ label: `0 ${resultKey}`, value: 'noresults', disabled: true }];
};
